import React, { useEffect, useRef, useState, useContext } from 'react';
import Logo from '../../Assets/images/Logo.svg';
import EnLogo from '../../Assets/images/LightEnLogo.svg';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { DirectionContext } from '../Contexts/DirectionContext';

export default function LightNavbar() {
    const [PathName, setPathName] = useState('/');
    const collapseRef = useRef();
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

    const {dir, setDir}= useContext(DirectionContext);

    const handleLinkClick = () => {
        collapseRef.current.classList.remove('show');
    };

    useEffect(() => {
        setPathName(location.pathname);
    }, [location.pathname]);

  const handleLanguageToggle = () => {
    const newLanguage = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLanguage).then(() => {
      setDir(newLanguage === 'ar' ? 'rtl' : 'ltr');
      document.title = newLanguage === 'en' ? 'Abdullah Aljasir For Lawyership and Legal Consultations Company' :'عبدالله الجاسر للمحاماة والاستشارات القانونية';
    });
    collapseRef.current?.classList.remove('show');
  };

  useEffect(() => {
    setDir(i18n.language === 'ar' ? 'rtl' : 'ltr');
    document.title = i18n.language === 'en' ? 'Abdullah Aljasir For Lawyership and Legal Consultations Company' :'عبدالله الجاسر للمحاماة والاستشارات القانونية';
  }, [i18n.language, setDir]);

    

    return (
        <div>
            <nav className="navbar navbar-expand-lg ">
                <div className="container-fluid mx-4 py-2">
                    <Link className="navbar-brand m-0" onClick={() => {
                        setPathName('/home');
                        handleLinkClick();
                    }}>
                        <img className="NavbarImage" src={dir === 'ltr' ? EnLogo : Logo} alt="Logo" />
                    </Link>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>

                    <div className="collapse navbar-collapse" id="navbarTogglerDemo02" ref={collapseRef}>
                        <ul className="navbar-nav m-auto gap-4 gap-xl-5 p-0">
                            <li className="nav-item ">
                                <Link to="/home" className="nav-link active" onClick={() => {
                                    setPathName('/home');
                                    handleLinkClick();
                                }}>
                                    <Trans i18nKey="home">الرئيسية</Trans>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/info/AboutUs" className="nav-link" onClick={() => {
                                    setPathName('/info/AboutUs');
                                    handleLinkClick();
                                }}>
                                    <Trans i18nKey="WhoUS">من نحن</Trans>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/info/services" className="nav-link" onClick={() => {
                                    setPathName('/info/services');
                                    handleLinkClick();
                                }}>
                                    <Trans i18nKey="services">خدماتنا</Trans>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/info/Blogs" className="nav-link" onClick={() => {
                                    setPathName('/info/Blogs');
                                    handleLinkClick();
                                }}>
                                    <Trans i18nKey="Blogs">مدونة</Trans>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/info/contact" className="nav-link" onClick={() => {
                                    setPathName('/info/contact');
                                    handleLinkClick();
                                }}>
                                    <Trans i18nKey="Contact">تواصل معنا</Trans>
                                </Link>
                            </li>
                        </ul>

                        <button className="nav-item language-Btn" onClick={handleLanguageToggle}>
                            <a className="nav-link">
                                {i18n.language === 'ar' ? 'English' : 'العربية'}
                            </a>
                        </button>
                    </div>
                </div>
            </nav>
        </div>
    );
}
